module.exports = __webpack_public_path__ + "bt.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/bt.svg
// module id = 722
// module chunks = 0